import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin, GoogleLogout } from 'react-google-login';
import {clientId_google} from './config/Settings';
import {register} from './config/Variables';
const clientId = clientId_google;

export default function Google() {
  const navigate = useNavigate();

    const clientId = clientId_google;

    const success = response => {
      const email =response.profileObj.email;
      const first_name =response.profileObj.givenName;
      const last_name =response.profileObj.familyName;
      const provider_id =response.profileObj.googleId;
      const provider ='Google';
      const device_name ='nokia';
      const profile_url =response.profileObj.imageUrl;
      const registered_by ='Website';

      let item = {email, provider_id, device_name,provider,first_name,last_name,profile_url,registered_by};
let result =  fetch(register,{
  method: 'POST',
  headers : {
    "Content-Type" : "application/json",
    "Accept" : 'application/json'
  },
  body: JSON.stringify(item)
}).then(response => response.json())
.then(data =>  {;

//result =await result.json();
if(data.message.code =='200'){
localStorage.setItem("user-info",JSON.stringify(data));
let user = JSON.parse(localStorage.getItem('user-info'));

user.user.first_name = response.profileObj.givenName;
        user.user.name = response.profileObj.givenName;
        user.user.display_name = response.profileObj.givenName;
if(data.message.newUser =='1'){
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
  event: 'sign_up',
  user_id: data.user.id,
  method: "google"
  });
  navigate('/personalize');
}else{
  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
  event: 'login',
  user_id: data.user.id,
  method: "google"
  });
  window.location.href = '/'; 
}
}
});
      
    }
    
    const error = response => {
      console.error(response) // eslint-disable-line
    }
    
    const loading = () => {
      console.log('loading') // eslint-disable-line
    }
    
    const logout = () => {
      console.log('logout') // eslint-disable-line
    }
    const responseGoogle = (response) => {
        console.log(response);
      }
    
    const MountTest = () => {
      const [showButton, toggleShow] = useState(true)
    
      if (showButton) {
        return (
          <GoogleLogin
            onSuccess={res => {
              toggleShow(false)
              success(res)
            }}
            onFailure={error}
            clientId={clientId}
          >
            Auth then Hide button
          </GoogleLogin>
        )
      }
    
      return <button onClick={() => toggleShow(true)}>show button</button>
    }
    

    return (
        <div>

    <GoogleLogin onSuccess={success} className="google_button button expanded" buttonText="الدخول بحساب غوغل" onFailure={error} clientId={clientId} />

   
  
        </div>
    );
   

}
 